export enum PortalPageEnum {
	PatientSettings = "PatientSettings",
	PatientDiary = "PatientDiary",
	CaseSettings = "CaseSettings"
}